import React from "react";

import { SkeletonBox } from "./styles";
import { PeriodFigureProps } from "./types";

export const PeriodFigure: React.FC<PeriodFigureProps> = ({
  status,
  skeletonWidth,
  children,
}) => {
  if (status === "loading") {
    return <SkeletonBox width={skeletonWidth} height="16px" />;
  }
  if (status === "unavailable") {
    return <>—</>;
  }
  return <>{children}</>;
};
